/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BicycleParkingLocationType {
    OUTDOOR = 'OUTDOOR',
    BUILDING = 'BUILDING',
    OTHER = 'OTHER',
}
